// Hizmet ikonları — TEK merkezi kayıt. Admin panelinde bu listeden seçilir;
// Landing, Booking ve admin listesi hep buradan render eder. Yeni bir ikon
// eklemek için: lucide-react'ten import et + aşağıya bir satır ekle. Böylece
// yeni ikon otomatik olarak hem seçicide hem de tüm görüntülerde çıkar.
import {
  Sparkles, Droplets, Droplet, Sofa, Armchair, SprayCan, Brush, Paintbrush,
  Wind, PanelTop, Refrigerator, WashingMachine, Hammer, Wrench, Briefcase,
  Building2, Home, Truck, Trees, Bug, Shirt, Car, Waves, Layers,
} from "lucide-react";

// { name (kayıtlı değer), label (Türkçe açıklama — ne için uygun), Icon }
export const SERVICE_ICONS = [
  { name: "Sparkles", label: "Parıltı — genel temizlik", Icon: Sparkles },
  { name: "Droplets", label: "Su damlaları — derin temizlik", Icon: Droplets },
  { name: "Droplet", label: "Damla — ıslak temizlik", Icon: Droplet },
  { name: "SprayCan", label: "Sprey — yüzey / yıkama", Icon: SprayCan },
  { name: "Brush", label: "Fırça — ovma / fırçalama", Icon: Brush },
  { name: "Waves", label: "Dalga — halı / yıkama", Icon: Waves },
  { name: "WashingMachine", label: "Makine — yıkama", Icon: WashingMachine },
  { name: "Sofa", label: "Koltuk — koltuk yıkama", Icon: Sofa },
  { name: "Armchair", label: "Tekli koltuk — döşeme", Icon: Armchair },
  { name: "Layers", label: "Katmanlar — halı", Icon: Layers },
  { name: "PanelTop", label: "Pencere — cam silme", Icon: PanelTop },
  { name: "Wind", label: "Rüzgar — havalandırma / kurutma", Icon: Wind },
  { name: "Refrigerator", label: "Buzdolabı — beyaz eşya", Icon: Refrigerator },
  { name: "Shirt", label: "Gömlek — çamaşır / kuru temizleme", Icon: Shirt },
  { name: "Briefcase", label: "Çanta — ofis / iş yeri", Icon: Briefcase },
  { name: "Building2", label: "Bina — apartman / site", Icon: Building2 },
  { name: "Home", label: "Ev — konut", Icon: Home },
  { name: "Hammer", label: "Çekiç — inşaat sonrası", Icon: Hammer },
  { name: "Wrench", label: "Anahtar — tamir / tadilat", Icon: Wrench },
  { name: "Paintbrush", label: "Boya fırçası — boya", Icon: Paintbrush },
  { name: "Truck", label: "Kamyon — nakliye / taşıma", Icon: Truck },
  { name: "Car", label: "Araba — araç yıkama", Icon: Car },
  { name: "Trees", label: "Ağaçlar — bahçe / peyzaj", Icon: Trees },
  { name: "Bug", label: "Böcek — ilaçlama", Icon: Bug },
];

export const SERVICE_ICON_MAP = Object.fromEntries(
  SERVICE_ICONS.map((i) => [i.name, i.Icon])
);

// İsimden bileşen — bilinmeyen isimde Sparkles'a düşer (asla boş dönmez).
export function serviceIcon(name) {
  return SERVICE_ICON_MAP[name] || Sparkles;
}

// ikon değeri yüklenen özel bir görsel mi? (data:URL / http / kök yol)
export function isCustomIcon(name) {
  return typeof name === "string" && /^(data:image|https?:\/\/|\/)/.test(name);
}

// Hizmet ikonunu render eden ortak bileşen: özel görselse <img>, değilse lucide.
// Her yerde (admin, Landing, Booking) bunu kullan → tutarlı görünüm.
export function ServiceIcon({ name, className }) {
  if (isCustomIcon(name)) {
    return <img src={name} alt="" className={className} style={{ objectFit: "contain" }} />;
  }
  const Ico = SERVICE_ICON_MAP[name] || Sparkles;
  return <Ico className={className} />;
}
